import React from 'react';

import { Altitude as AltitudeUI } from '@/components/ui/dashboard/Monitor';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const Altitude = ({ data: robotId }) => {
  const globalPosition = useRobotTelemetry(robotId, MESSAGE.GLOBAL_POSITION_INT);

  return <AltitudeUI relAltitude={globalPosition?.ralt ?? 0} />;
};

export default Altitude;
